import {ChevronRightIcon, MinusIcon, PlusIcon} from '@heroicons/react/outline';
import {useState} from 'react';

import {Badge, Button, Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AfriexReferralTier} from '@/types';
import {statusColors} from '@/types/Transaction';
import * as formatDate from '@/utils/date';

import TierSummary from './Summary';

const MerchantTierTable = ({items}: {items: AfriexReferralTier[]}) => {
  return (
    <Table>
      <Thead>
        <Tr enableHover={false}>
          <Th className="w-20">&nbsp;</Th>
          <Th className="py-4 text-left">Name</Th>
          <Th className="py-4 text-left">Commission Type</Th>
          <Th className="py-4 text-left">Referrer Bonus</Th>
          <Th className="py-4 text-left">Status</Th>
          <Th className="py-4 text-left">Date</Th>
          <Th className="w-20">&nbsp;</Th>
        </Tr>
      </Thead>

      <TBody>
        {items.map((item, index) => (
          <MerchantTierTableRow key={index} item={item} index={index} />
        ))}
      </TBody>
    </Table>
  );
};

const MerchantTierTableRow = ({
  item,
  index,
}: {
  item: AfriexReferralTier;
  index: number;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const status = item?.isDeactivated ? 'Inactive' : 'Active';
  const statusColor =
    statusColors[item?.isDeactivated ? 'processing' : 'successful'];
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <>
      <Tr className={zebraRow}>
        <Td isNumeric>
          <Button onClick={() => setIsExpanded(!isExpanded)} variant="unStyled">
            <div
              className={`border-2 border-gray-700 dark:border-dark-borderLight w-5 h-5 flex justify-center rounded hover:bg-cyan-50 ${
                isExpanded ? 'bg-cyan-50' : ''
              }`}
            >
              {isExpanded ? (
                <MinusIcon className="w-4 h-4 text-gray-700 dark:text-gray-100" />
              ) : (
                <PlusIcon className="w-4 h-4 text-gray-700 dark:text-gray-100" />
              )}
            </div>
          </Button>
        </Td>

        <Td className={`font-medium`}>{item.name}</Td>
        <Td className={`font-medium capitalize`}>
          {item.commissionType || 'N/A'}
        </Td>
        <Td className={`font-medium`}>
          {item.bonusAmountPerReferrer ?? 'N/A'}
        </Td>
        <Td>
          <Badge label={status} colorScheme={statusColor} />
        </Td>
        <Td>{formatDate.DDMonYYYY(item.createdAt?.toString() || '')}</Td>
        <Td>
          <div className="w-5 h-5 flex justify-center text-gray-700 dark:text-gray-300 hover:border rounded-lg hover:border-gray-300 hover:bg-cyan-50 hover:text-cyan-500">
            <ChevronRightIcon className="w-5 h-5" />
          </div>
        </Td>
      </Tr>

      {isExpanded && (
        <Tr enableHover={false}>
          <Td colSpan={9} className="p-0 m-0">
            <div className="flex py-10 px-8 justify-center bg-sky-50 dark:bg-transparent w-full">
              <TierSummary item={item} />
            </div>
          </Td>
        </Tr>
      )}
    </>
  );
};

export default MerchantTierTable;
